import { Navbar, Nav, Container, Row, Col } from 'react-bootstrap';
// import './CustomHeader.css'; // Custom CSS file for additional styling

import './CustomHeader.css';
import { IoIosArrowDown, IoIosMenu } from 'react-icons/io';
import { Link } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useExhibitorAuthContext } from '../../Context/AuthContex/ExhibitorAuthContext';
import { VisitorAuthContext } from '../../Context/AuthContex/VisitorAuthContext';
import { B2BAuthContext } from '../../Context/AuthContex/B2BAuthContext';
import {
  AUTH_VISITOR_USER_FAILED,
  B2B_USER_FAILED,
  EXHIBITOR_USER_FAILED,
} from '../../Helpers/Constant';

const CustomHeader = () => {
  const queryClient = useQueryClient();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  const { visitorUser, dispatch: VisitorAuthDispatch } = VisitorAuthContext();
  const {
    state: { b2bUser },
    dispatch: B2BAuthDispatch,
  } = B2BAuthContext();

  const handleLogoutExhibitor = () => {
    localStorage.removeItem('toab_exibitor_token');
    authDispatch?.({
      type: EXHIBITOR_USER_FAILED,
    });
    queryClient.clear();
  };
  const handleLogout = () => {
    localStorage.removeItem('toab_visitor_token');
    VisitorAuthDispatch?.({
      type: AUTH_VISITOR_USER_FAILED,
    });
    queryClient.clear();
  };

  const handleLogoutB2B = () => {
    localStorage.removeItem('toab_fair');
    B2BAuthDispatch?.({
      type: B2B_USER_FAILED,
    });

    queryClient.clear();
  };

  const renderLoginButtons = () => {
    if (exhibitorUser?.token) {
      return (
        <Row>
          <Col>
            {' '}
            <Link to='/profile' className='text-white text-decoration-none'>
              <button className='me-2 header-button'>Profile</button>
            </Link>
          </Col>
          <Col>
            {' '}
            <button onClick={handleLogoutExhibitor} className='header-button1'>
              Logout
            </button>
          </Col>
        </Row>
      );
    } else if (visitorUser?.token) {
      return (
        <Row>
          <Col>
            <Link
              to='/visitor/profile'
              className='text-white text-decoration-none'
            >
              <button className='me-2 header-button'>Profile</button>
            </Link>
          </Col>
          <Col>
            {' '}
            <button onClick={handleLogout} className='header-button1'>
              Logout
            </button>
          </Col>
        </Row>
      );
    } else if (b2bUser?.token) {
      return (
        <Row>
          <Col>
            {' '}
            <Link to='/b2b/profile' className='text-white text-decoration-none'>
              <button className='me-2 header-button'>Profile</button>
            </Link>
          </Col>
          <Col>
            {' '}
            <button onClick={handleLogoutB2B} className='header-button1'>
              Logout
            </button>
          </Col>
        </Row>
      );
    } else {
      return (
        <Row className='gap-2 px-2'>
          <Col style={{ padding: 0 }}>
            <div className='dropdown-container'>
              <button className='header-button w-100 text-uppercase'>
                Registration
              </button>
              <div className='dropdown-menu'>
                <Link to='/visitor-registration' className='dropdown-item'>
                  Visitor
                </Link>
                <Link to='/book-your-space' className='dropdown-item'>
                  Exhibitor
                </Link>
                <Link
                  to='/b2b-registration?type=Buyer'
                  className='dropdown-item'
                >
                  Buyer
                </Link>
                <Link
                  to='/b2b-registration?type=Seller'
                  className='dropdown-item'
                >
                  Seller
                </Link>
                <Link
                  to='/b2b-registration?type=Both'
                  className='dropdown-item'
                >
                  Buyer/Seller
                </Link>
              </div>
            </div>
          </Col>
          <Col style={{ padding: 0 }}>
            <div className='dropdown-container'>
              <button
                onClick={handleLogoutB2B}
                className='header-button1 w-100 text-uppercase'
              >
                Login
              </button>
              <div className='dropdown-menu'>
                <Link to='/visitor-login' className='dropdown-item'>
                  Visitor
                </Link>
                <Link to='/login' className='dropdown-item'>
                  Exhibitor
                </Link>
                <Link to='/b2b-login?type=Buyer' className='dropdown-item'>
                  Buyer
                </Link>
                <Link to='/b2b-login?type=Seller' className='dropdown-item'>
                  Seller
                </Link>
                <Link to='/b2b-login?type=Both' className='dropdown-item'>
                  Buyer/Seller
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      );
    }
  };
  return (
    <>
      <header className='custom-header'>
        <Container
          fluid
          style={{
            // marginTop: '20px',
            paddingTop: '5px',
            paddingBottom: '5px',
            // padding: '10px 0px',
            // background: '#0A1A2F',
          }}
        >
          <Row className='align-items-center'>
            <Col
              xs={12}
              md={3}
              lg={3}
              className='text-center text-md-start'
              style={{ display: 'flex', justifyContent: 'center' }}
            >
              <img
                src='/assets/logo2.png'
                alt='Asian Tourism Fair'
                className='header-logo'
              />
            </Col>

            {/* Event Info Section */}
            <Col
              xs={12}
              md={5}
              lg={6}
              className='text-center middle-image-header d-none d-md-block'
            >
              <img
                src='/assets/header_bg.jpg'
                alt='13th Asian Tourism Fair ATF 2026'
                className='header-middle-image'
              />
            </Col>

            {/* Buttons Section */}

            <Col xs={12} md={4} lg={3} className='text-end'>
              {renderLoginButtons()}
            </Col>
          </Row>
        </Container>
      </header>

      <Navbar expand='md' className='sub-header'>
        <Container>
          <Navbar.Toggle aria-controls='basic-navbar-nav'>
            <IoIosMenu size={22} style={{ color: '#c62128' }} />
          </Navbar.Toggle>
          <Navbar.Collapse id='basic-navbar-nav'>
            <Nav className='mx-auto d-flex gap-2 align-items-center header-nav'>
              <div className='nav-item-with-submenu'>
                <Nav.Link
                  href='https://www.asiantourismfair.com/'
                  className='nav-menu-link'
                >
                  Home
                </Nav.Link>
              </div>

              <div className='nav-item-with-submenu'>
                <Nav.Link href='#about' className='nav-menu-link'>
                  Event <IoIosArrowDown />
                </Nav.Link>
                <div className='submenu'>
                  <Link
                    to={`/event-list`}
                    className='text-decoration-none nav-link'
                  >
                    Event List
                  </Link>
                </div>
              </div>

              <div className='nav-item-with-submenu'>
                <Link to={`/all-exhibitor`} className='header-btn'>
                  Exhibitors
                </Link>
              </div>

              <div className='nav-item-with-submenu'>
                <Link to={`/product-services`} className='header-btn'>
                  Product & Service
                </Link>
              </div>

              <div className='nav-item-with-submenu'>
                <Link
                  to={`/profile/space-requirements?isSpace=available`}
                  className='header-btn header-btn-green'
                >
                  Book Your Space
                </Link>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default CustomHeader;
